import { format } from 'date-fns';
import { parseSessionInstant } from './sessionInstant';

type TranscriptSessionLike = { session_start_at?: string | null };

export function findMostRecentSessionDate(
  sessionDates: string[] | null | undefined
): string | null {
  if (!Array.isArray(sessionDates) || sessionDates.length === 0) {
    return null;
  }

  let mostRecentDate: string | null = null;
  let mostRecentTimestamp = Number.NEGATIVE_INFINITY;

  for (const sessionDate of sessionDates) {
    const trimmed = sessionDate.trim();
    const timestamp = parseSessionInstant(trimmed)?.getTime();
    if (timestamp === undefined) {
      continue;
    }
    if (timestamp > mostRecentTimestamp) {
      mostRecentTimestamp = timestamp;
      mostRecentDate = trimmed;
    }
  }

  return mostRecentDate;
}

export function formatShareSessionDate(sessionDates: string[] | null | undefined): string {
  const mostRecentSessionDate = parseSessionInstant(findMostRecentSessionDate(sessionDates));
  return mostRecentSessionDate ? format(mostRecentSessionDate, 'MMM d, yyyy') : 'this';
}

export function formatShareSessionDateFromTranscriptSessions(
  transcriptSessions: TranscriptSessionLike[] | null | undefined
): string {
  if (!Array.isArray(transcriptSessions) || transcriptSessions.length === 0) {
    return 'this';
  }

  const sessionDates = transcriptSessions.map((session) => session?.session_start_at ?? '');
  return formatShareSessionDate(sessionDates);
}
